import { useEffect, useState } from "react";
import api, { formatDate, formatIDR } from "../lib/api";
import { RiskBadge, ScorePill } from "../components/badges";
import ClaimDetailSheet from "../components/ClaimDetailSheet";
import { Stamp } from "@phosphor-icons/react";

export default function ApprovalPage() {
  const [claims, setClaims] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const load = () => api.get("/claims", { params: { status: "menunggu_approval" } }).then((r) => setClaims(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="p-8" data-testid="approval-page">
      <h1 className="text-2xl font-semibold tracking-tight">Antrean Approval</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-6">Klaim dengan rekomendasi investigator eksternal — membutuhkan persetujuan supervisor</p>

      {claims.length === 0 ? (
        <div className="bg-card border border-border p-12 text-center" data-testid="empty-approval">
          <Stamp size={32} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">Tidak ada klaim menunggu approval saat ini</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {claims.map((c) => (
            <button key={c.id} data-testid={`approval-card-${c.claim_number}`} onClick={() => setSelectedId(c.id)}
              className="text-left bg-card border border-border p-5 hover:-translate-y-px hover:border-slate-400 transition-transform duration-200">
              <div className="flex items-center justify-between mb-3">
                <span className="font-mono text-xs font-semibold">{c.claim_number}</span>
                <RiskBadge category={c.risk_category} />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <ScorePill score={c.score} />
                <span className="text-xs text-muted-foreground capitalize">Asuransi {c.claim_type}</span>
              </div>
              <p className="text-sm font-medium">{c.reporter_name}</p>
              <p className="text-xs text-muted-foreground">{c.province} · {formatDate(c.created_at)}</p>
              <p className="text-sm font-mono mt-2">{formatIDR(c.claim_amount)}</p>
            </button>
          ))}
        </div>
      )}

      <ClaimDetailSheet claimId={selectedId} onClose={() => setSelectedId(null)} onChanged={load} />
    </div>
  );
}
